import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId.ts';
import { AutoExpandPlan } from '@/types/autoExpandPlan.ts';
import { RUN_AUTO_EXPAND_PLAN_KEY } from '@/utils/queryKeys.ts';
import { get_run_auto_expand_plan_url } from '@/utils/urls.ts';

const useRetrieveAutoExpandPlan = (): UseQueryResult<AutoExpandPlan, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const runId = useRunId();

  return useQuery({
    queryKey: RUN_AUTO_EXPAND_PLAN_KEY(automationId, runId),
    queryFn: async () => (await apiClient.get(get_run_auto_expand_plan_url(runId))).data,
    enabled: false,
  });
};

export default useRetrieveAutoExpandPlan;
